<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="true"></sub-header>
<p-scrollPanel *ngIf="loaded" [style]="{width: '100%', height: '70vh'}" styleClass="custombar1">
  <div *ngIf="isLoaded()" class="container-fluid mb-5">
    <!-- Informacion de la oferta -->
    <div class="row m-b-lg">
      <div class="col-12">
        <h3>{{ 'TenderInfo.tenderData' | translate }}</h3>
      </div>
      <div class="col-12">
        <dl class="row">
          <dt class="col-12 col-md-4">{{ 'TenderInfo.tenderType' | translate }}:</dt>
          <dd class="col-12 col-md-8">
            <span *ngIf="tender.electronic">
              <i class="fa fa-envelope" aria-hidden="true"></i> {{ 'TenderInfo.electronic' | translate }}</span>
            <span *ngIf="!tender.electronic">
              <i class="fa fa-envelope" aria-hidden="true"></i> {{ 'TenderInfo.paper' | translate }}</span>
          </dd>
          <dt class="col-12 col-md-4">{{ 'TenderInfo.registerNumber' | translate }}:</dt>
          <dd class="col-12 col-md-8">
            <span *ngIf="tender.numRegister">{{ tender.numRegister }}</span>
          </dd>
          <dt class="col-12 col-md-4">{{ 'TenderInfo.registerDate' | translate }}:</dt>
          <dd class="col-12 col-md-8">
            <span *ngIf="tender.dateTender">{{ tender.dateTender | date: 'dd-MM-yyyy HH:mm:ss' }}</span>
          </dd>
          <dt class="col-12 col-md-4">{{ 'TenderInfo.company' | translate }}:</dt>
          <dd class="col-12 col-md-8">
            <b>[{{ tender.company.taxIdentifier }}]</b> - <span *ngIf="tender.company.name">{{ tender.company.name
              }}</span>
            <span *ngIf="!tender.company.name">{{ tender.company.commercialName }}</span>
          </dd>
        </dl>
      </div>
      <!-- DOCUMENTACION DE LA OFERTA -->
      <div class="col-12" *ngFor="let envelope of decipheredEnvelopes">
        <p-panel class="col-12 m-b-md">
          <p-header>
            <!-- <span class="leyenda float-right">{{ 'Procedures.total' | translate }} {{ getEnvelopeDocumentCount(envelope)
              }}</span> -->
            <i class="fa fa-envelope" aria-hidden="true"></i> {{ getEnvelopeDescription(envelope) }}
          </p-header>
          <div class="row">
            <div class="col-12">
              <!-- OPCION1: VISUALIZACION UTILIZANDO EL COMPONENTE -->
              <!--
                    <div *ngFor="let document of envelope.documentEnvelope">
                      <POR EL MOMENTO NO MOSTRAMOS LOS VACIOS>
                      <div *ngIf="document.file">
                        <span class="label label-default">{{document.nameDocument}}</span>
                        <documentFile [edit]="false" [fileDetails]="document.file"></documentFile>
                      </div>
                    </div>
                  -->
              <!-- OPCION2: VISUALIZACION EN MODO TABLA -->
              <p-table [value]="envelope.documentEnvelope" class="col-12" sortField="identifier" dataKey="identifier"
                [expandedRowKeys]="expandedRows" [responsive]="true" [rows]="20"
                [paginator]="envelope.documentEnvelope && envelope.documentEnvelope.length > 20" [pageLinks]="4"
                [rowsPerPageOptions]="[15, 30, 100]">
                <ng-template pTemplate="header">
                  <tr>
                    <th [style.width]="'3%'"></th>
                    <th [style.width]="'3%'"></th>
                    <th [style.width]="'35%'">{{ colHeaders[0] | translate }}</th>
                    <th [style.width]="'35%'">{{ colHeaders[1] | translate }}</th>
                    <th class="action-button text-center"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-expanded="expanded" let-document>
                  <tr>
                    <td>
                      <a href="#" [pRowToggler]="document"
                        *ngIf="document?.file?.signatures && document?.file?.signatures?.length > 0">
                        <i [ngClass]="expanded ? 'fas fa-lg fa-chevron-down' : 'fas fa-lg fa-chevron-right'"></i>
                      </a>
                    </td>
                    <td>
                      <!-- COL1: ICONO DOCUMENTO -->
                      <span *ngIf="document.file?.name">
                        <i class="fa fa-lg" [ngClass]="
                            documentService.getIconType(document.file.name)
                          " aria-hidden="true"></i>
                      </span>
                    </td>
                    <td>
                      <!-- COL2: NOMBRE DOCUMENTO -->
                      <span class="p-column-title">{{ colHeaders[0] | translate }}</span> {{ document.nameDocument }}
                    </td>
                    <td>
                      <!-- COL3: DESCRIPCION DOCUMENTO -->
                      <span class="p-column-title">{{ colHeaders[1] | translate }}</span> {{ document.file?.name }}
                    </td>
                    <td>
                      <div class="btn-group float-right">
                        <i *ngIf="document?.see" class="fa fa-2x fa-check btn border-0 text-success"></i>
                        <button *ngIf="document.file && this.documentService.isPdf(document.file)"
                          class="btn btn-primary btn-sm t-action-button" (click)="viewFile(document)"
                          title="{{ 'General.visualize' | translate }}">
                          <i class="fa fa-eye" aria-hidden="true"></i><span class="d-none d-sm-inline"></span>
                        </button>
                        <button *ngIf="document.file" class="btn btn-default btn-sm t-action-button"
                          (click)="downloadEmbedded(document)" title="{{ 'General.download' | translate }}">
                          <i class="fas fa-download" aria-hidden="true"></i><span class="d-none d-sm-inline"></span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-document>
                  <tr>
                    <td colspan="7">
                      <div *ngIf="document?.file?.signatures">
                        <div *ngFor="
                          let signature of signatures(document.file);
                          let o = index
                        " class="panel-footer">
                          <div class="float-right">
                            <a class="btn btn-outline-secondary btn-sm" (click)="
                              documentService.validateSignDocument(
                                signature,
                                document.file
                              )
                            ">
                              <i class="fa fa-certificate" aria-hidden="true"></i>
                              <span class="d-none d-sm-inline"> {{ 'DocumentFile.validate.signature' | translate
                                }}</span>
                            </a>
                          </div>
                          <a class="float-left" (click)="
                            documentService.validateSignDocument(
                              signature,
                              document.file
                            )
                          ">
                            <img alt="image" src="assets/img/CERES.gif" />
                          </a>
                          <strong>{{ signature.signer }}</strong> <br />
                          <small class="text-muted">{{ signature.date | date: 'dd-MM-yyyy HH:mm' }}</small>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr class="text-center">
                    <td colspan="5">{{ 'General.noData' | translate }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
  </div>
</p-scrollPanel>